module.exports = __webpack_public_path__ + "img/File.85603b9.svg";